































import { Prop, VModel, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { FilePurpose } from "@/shared/model/enumerations/file-purpose.model";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";
import VideoPlayer from "@/custom/copy/VideoPlayer.vue";

@Component({
  components: {
    VideoPlayer,
  },
})
export default class PreviewFileDialog extends Vue {
  @VModel({ type: Boolean }) open;
  @Prop() title;
  @Prop() fileGeodetic;

  videoUrl = '';
  m3u8VideoUrl = '';
  imgUrl = '';
  fileGeodeticData: any = {};
  fileGeodeticService = new FileGeodeticService();

  @Watch('fileGeodetic')
  onFileGeodeticChange(val, oldVal) {
    this.fileGeodeticData = val;
    this.setUrl();
  }

  private setUrl() {
    if (this.fileGeodeticData.filePurpose === FilePurpose.VIDEO) {
      let fileGeodeticService = new FileGeodeticService();
      this.videoUrl = fileGeodeticService.streamVideoLink(this.fileGeodeticData.id);
      this.videoOptions.sources = [
        {
          type: 'application/x-mpegURL',
          src: fileGeodeticService.m3u8VideoLink(this.fileGeodeticData.id),
        },
        {
          type: 'video/mp4',
          src: fileGeodeticService.streamVideoLink(this.fileGeodeticData.id),
        },
      ];
      // this.videoUrl = fileGeodeticService.m3u8VideoLink(this.fileGeodeticData.id);
    } else if (this.fileGeodeticData.filePurpose === FilePurpose.IMG) {
      let fileGeodeticService = new FileGeodeticService();
      this.imgUrl = fileGeodeticService.downloadLink(this.fileGeodeticData.id);
    } else {
      this.videoUrl = '';
      this.imgUrl = '';
    }
  }

  @Watch('open')
  onOpenChange(val, oldVal) {
    if (!val) {
      this.videoUrl = '';
      this.imgUrl = '';
    } else {
      this.setUrl();
    }
  }

  videoOptions = {
    autoplay: false,
    controls: true,
    sources: [],
  };
}
